export const paymentWeekOptions = [
    { value: '1', name: '1. HAFTA' },
    { value: '2', name: '2. HAFTA' },
    { value: '3', name: '3. HAFTA' },
    { value: '4', name: '4. HAFTA' },
]

export const currenciesOptions = [
    { value: 'TL', name: 'TL' },
    { value: 'USD', name: 'USD' },
    { value: 'EUR', name: 'EURO' },
    { value: 'USDEUR', name: 'USD/EUR' },
]

export const overseasConnectionYesNoOptions = [{ value: 'E', name: 'Evet' }, { value: 'H', name: 'Hayır' }]

export const WINGS = "wings"
export const AXESS = "axess"
export const IS_TURU_SERBEST_MESLEK = 3

export const dayOptions = Array.from({ length: 31 }, (_, i) => {
    const day = String(i + 1).padStart(2, '0');
    return { value: day, name: day };
});

export const monthOptions = [
    { value: '01', name: "Ocak" },
    { value: '02', name: "Şubat" },
    { value: '03', name: "Mart" },
    { value: '04', name: "Nisan" },
    { value: '05', name: "Mayıs" },
    { value: '06', name: "Haziran" },
    { value: '07', name: "Temmuz" },
    { value: '08', name: "Ağustos" },
    { value: '09', name: "Eylül" },
    { value: '10', name: "Ekim" },
    { value: '11', name: "Kasım" },
    { value: '12', name: "Aralık" }
];

const currentYear = new Date().getFullYear();
export const yearOptions = Array.from({ length: currentYear - 1899 }, (_, i) => {
    const year = currentYear - i;
    return { value: year.toString(), name: year.toString() };
});

export const GENERIC_ERROR_CODES = {
    MSRED: "RED",
    MSIPTAL: "IPTAL",
    NOTELIGIBILITY: "NOTELIGIBILITY",
    
}

export const YES = "YES"
export const NO = "NO"

